export default __webpack_public_path__ + "media/images/logos/logo_dark-066396559060e38dc9e1efabc3b4af95.png";